import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { apiUrl } from "../../../services/constants";
import { GET_CERTIFICATION } from "../../../services/graphql-query";
import { Row, Col } from 'react-bootstrap';

const Certifications = () => {

    const category = window.localStorage.getItem("category");
    const collection = window.localStorage.getItem("product_name");

    const { data } = useQuery(GET_CERTIFICATION, { variables: { category: category, collection, collection } });

    let certificationData = [];
    if (data) {
        certificationData = data.certifications.data;
    }

    return (
        <React.Fragment>
            <div className="mobile-hide">
                <Row className="mt-5 mb-5">
                    {certificationData.length ? certificationData.map((item, key) =>
                        item.attributes.Image.data.map((item1, key1) => (
                            <Col className="mt-4" md={2} key={key1}>
                                <div className="certificaion-content">
                                    <img src={apiUrl + item1.attributes.url} alt={item1.attributes.name} />
                                </div>
                            </Col>
                        ))
                    ) : <p className="empty-data">No data</p>}
                </Row>
            </div>
            <Row className="mobile-show">
                {certificationData.length ? certificationData.map((item, key) =>
                    item.attributes.Image.data.map((item1, key1) => (
                        <div className="mt-4 pl-5 pr-5" key={key1}>
                            <div className="certificaion-content">
                                <img src={apiUrl + item1.attributes.url} alt={item1.attributes.name} width="300px" height="300px" />
                            </div>
                        </div>
                    ))
                ) : <p className="empty-data">No data</p>}
            </Row>
        </React.Fragment >
    )
}

export default Certifications;